import { render, staticRenderFns } from "./PreviewProtocal.vue?vue&type=template&id=5f819366&scoped=true&"
import script from "./PreviewProtocal.vue?vue&type=script&lang=js&"
export * from "./PreviewProtocal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewProtocal.vue?vue&type=style&index=0&id=5f819366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f819366",
  null
  
)

export default component.exports